import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faWrench, faBatteryQuarter } from '@fortawesome/free-solid-svg-icons'
import { DeviceStatus } from '../utils/deviceStatus'

interface DeviceStatusIconProps {
  status: DeviceStatus
  lowBattery?: boolean
  size?: 'sm' | 'md'
  className?: string
}

export function DeviceStatusIcon({ status, lowBattery, size = 'sm', className = '' }: DeviceStatusIconProps) {
  const sizeClass = size === 'sm' ? 'text-[8px]' : 'text-[10px]'

  const statusColors: Record<DeviceStatus, string> = {
    online: 'text-green-500',
    offline: 'text-gray-300',
    pending: 'text-gray-300',
    config: 'text-gray-300',
  }

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {status === 'config' ? (
        <FontAwesomeIcon icon={faWrench} className={`${sizeClass} text-gray-300`} />
      ) : (
        <FontAwesomeIcon icon={faCircle} className={`${sizeClass} ${statusColors[status]}`} />
      )}
      {lowBattery && (
        <FontAwesomeIcon
          icon={faBatteryQuarter}
          className="text-[10px] text-amber-500 animate-pulse"
        />
      )}
    </span>
  )
}
